import AppHeader from '../AppHeader'
import AppHeaderNoauth from '../AppHeaderNoauth'
import EsMyCardSubMenu from '../EsMyCardSubMenu'

export default {
  name: 'facingtype-card-exchange-select',
  components: {
    AppHeader,
    AppHeaderNoauth,
    EsMyCardSubMenu
  },
  data: () => ({
    isAuthenticated: false
  }),
  created: function () {
    if (window.localStorage.getItem('access_token')) {
      this.isAuthenticated = true
    }
  },
  methods: {
    getCard () {
      const getCardUrl = '/facing_type_card/get_new'
      if (!this.isAuthenticated) {
        this.$router.push({ path: '/login', query: { redirect: getCardUrl } })
        return
      }
      this.$router.push(getCardUrl)
    },
    giveCard () {
      const giveCardUrl = '/facing_type_card/give_new'
      if (!this.isAuthenticated) {
        this.$router.push({ path: '/login', query: { redirect: giveCardUrl } })
        return
      }
      this.$router.push(giveCardUrl)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/facingtype-card-exchange-select.js